import Parse from '@/parse'
const App = Parse.Object.extend('App')

export default {
  initForm ({ state, commit }) {
    commit('setTitle', state.app.get('title'))
    commit('setLocale', state.app.get('locale'))
  },

  async getApp({ commit }) {
    let query = new Parse.Query(App)
    let app = await query.first()
    commit('setApp', app)
  },

  async save({ state, dispatch }) {
    let app = state.app
    if(!app) { app = new App() }
    app.set('title', state.title)
    app.set('locale', state.locale)

    try {
      await app.save()
      return 'アプリ設定を更新しました。'
    } catch (error) {
      console.log(error)
      dispatch(
        'snackBar/addMessage',
        error,
        { root: true }
      )
    }
  }
}
